"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NIKE_API_CALLER_ID = void 0;
var PACKAGE_MAJOR_MINOR = 'v3';
var NIKE_API_CALLER_ID = exports.NIKE_API_CALLER_ID = "nike:dotcom.nav:".concat(PACKAGE_MAJOR_MINOR);